<div class="mobile-qa-form">
  <kl-qa-form (postCreated)="onQaCreated($event)">
  </kl-qa-form>
</div>
